import React from 'react';
import { BarChart3 } from 'lucide-react';

const DivisionAnalyticsWidget = ({ stats = {} }) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-3 gap-3">
        <div className="p-3 bg-blue-50 rounded-lg text-center">
          <p className="text-2xl font-bold text-blue-900">{stats.totalStudents || 0}</p>
          <p className="text-xs text-gray-600">Students</p>
        </div>
        <div className="p-3 bg-green-50 rounded-lg text-center">
          <p className="text-2xl font-bold text-green-900">{stats.avgAttendance || 0}%</p>
          <p className="text-xs text-gray-600">Attendance</p>
        </div>
        <div className="p-3 bg-red-50 rounded-lg text-center">
          <p className="text-2xl font-bold text-red-900">{stats.atRisk || 0}</p>
          <p className="text-xs text-gray-600">At Risk</p>
        </div>
      </div>

      <div className="h-32 bg-gray-100 rounded-lg flex items-center justify-center">
        <BarChart3 className="w-8 h-8 text-gray-400" />
      </div>
    </div>
  );
};

export default DivisionAnalyticsWidget;